import GlobalVariable from '@/global/global-variable'

// 查询系统参数
const searchParam = GlobalVariable.BASE_PATH + "/rest/system/param/search";

// 修改系统参数
const updateParam = GlobalVariable.BASE_PATH + "/rest/system/param/update";

// 查询消失时间
const getDisappearTime = GlobalVariable.BASE_PATH + "/rest/system/param/getDisappearTime";

export default {
    searchParam,
    updateParam,
    getDisappearTime,
}



// WEBPACK FOOTER //
// ./src/request/api-param.js